import "./language-switch.css";
import React from "react";
import { useTranslation } from "react-i18next";

type SupportedLang = "de" | "en";

const LANGUAGES: { code: SupportedLang; label: string }[] = [
    { code: "de", label: "DE" },
    { code: "en", label: "EN" },
];

export function LanguageSwitch() {
    const { i18n } = useTranslation();

    // i18next liefert manchmal "de-CH" etc. -> nur die ersten 2 Buchstaben nehmen
    const currentLang = (i18n.language?.slice(0, 2).toLowerCase() ||
        "de") as SupportedLang;

    const handleChangeLanguage = (lang: SupportedLang) => {
        if (lang === currentLang) return;
        i18n.changeLanguage(lang);
    };

    return (
        <div className="lang-switch">
            {LANGUAGES.map((lang, index) => (
                <React.Fragment key={lang.code}>
                    <button
                        type="button"
                        className={
                            "lang-switch__item" +
                            (currentLang === lang.code ? " lang-switch__item--active" : "")
                        }
                        onClick={() => handleChangeLanguage(lang.code)}
                    >
                        {lang.label}
                    </button>
                    {index < LANGUAGES.length - 1 && (
                        <span className="lang-switch__divider">|</span>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
}
